/**
 * Why a track title still looks like a file name, or null — for the
 * moderation queue, so a name like "inbound8508…" or "MEU MUNDO 2025 prod by X"
 * is fixed (Editar) before approving.
 *
 * ⚠️ A short copy of titleWarning() in izenu-web-app/src/lib/trackTitle.ts
 * and TrackTitle::warning() in the PHP backend. Change all three.
 */

const MEANINGLESS = [
    /^inbound\d*/iu,
    /^(?:aud|ptt|vid|img|audio|voice|rec|recording|grava[cç][aã]o|whatsapp\s*(?:audio|[aá]udio|ptt))[\s_-]*(?:\d|wa\d|$)/iu,
    /^(?:[aá]udio|track|faixa|m[uú]sica|som|memo)\s*[-_#.]?\s*\d+$/iu,
    /^(?:untitled|sem\s+t[ií]tulo|novo\s+[aá]udio|new\s+recording|nova\s+grava[cç][aã]o|voice\s+memo|[aá]udio|track|faixa)$/iu,
    /^(?=(?:\D*\d){5})[\d\s_\-.()]+$/u,
    /^[a-f0-9-]{16,}$/iu,
];

function isAllCaps(t) {
    const letters = t.replace(/(?<![\p{L}])(?:x|feat\.?|ft\.?)(?![\p{L}])/giu, '').replace(/[^\p{L}]/gu, '');
    return [...letters].length >= 4 && !/\p{Ll}/u.test(letters);
}

function hasYear(t) {
    const max = new Date().getFullYear() + 1;
    const isYear = (y) => Number(y) >= 1990 && Number(y) <= max;
    const paren = t.match(/[([]\s*((?:19|20)\d{2})\s*[)\]]/u);
    if (paren && isYear(paren[1])) return true;
    const end = t.match(/^(.*?)[\s\-–_,.]+((?:19|20)\d{2})\s*$/u);
    return !!end && isYear(end[2]) && /\p{L}{2,}/u.test(end[1])
        && !/(?:^|\s)(de|do|da|em|desde|ano|of|in|since|class|ver[ãa]o)$/iu.test(end[1].trim());
}

export function titleWarning(title) {
    const t = (title || '').normalize('NFC').trim();
    if (t === '') return null;
    const bare = t.replace(/\.(mp3|mpeg|mpga|wav|flac|m4a|aac|ogg|opus)$/iu, '').trim();
    if (MEANINGLESS.some((re) => re.test(bare))) return 'Parece o nome de um ficheiro, não da música.';
    if (/\.(mp3|wav|flac|m4a)\b|\d{6,}|_/iu.test(t)) return 'Parece o nome de um ficheiro.';
    if (isAllCaps(t)) return 'Está todo em maiúsculas.';
    if (/(?<!\p{L})(oficial|official|v[ií]deo|lyrics?|prod(?:\.|uzido|uced)?\s*(?:by|por))(?!\p{L})|www\.|\.com\b/iu.test(t)) {
        return 'Tem texto que não faz parte do nome (vídeo oficial, produtor, site…).';
    }
    if (hasYear(t)) return 'Tem o ano no nome.';
    return null;
}
